import * as React from 'react';
import { Modal } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import withStyles from 'react-jss';
import PdfRenderer from 'src/common/PdfRenderer';
import { CssType, ThemeType } from 'src/theme/jss-types';

const styles = (theme: ThemeType): CssType => ({
  viewButton: {
    background: 'none',
    border: 'none',
    color: '#1890ff',
    cursor: 'pointer',
    padding: 0,
  },
  modal: {
    top: 20,
  },
  modalBody: {
    height: '80vh',
    padding: 0,
  },
});

interface AttachmentLinkProps {
  url: string;
  classes: {
    viewButton: string;
    modal: string;
    modalBody: string;
  };
}

const AttachmentLink: React.FC<AttachmentLinkProps> = ({ url, classes }) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsModalVisible(true);
    setIsLoading(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsLoading(true);
  };

  React.useEffect(() => {
    if (isModalVisible) {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 100);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isModalVisible]);

  if (!url) return <>-</>;

  return (
    <div>
      <button
        type="button"
        onClick={handleClick}
        className={classes.viewButton}
      >
        <PaperClipOutlined /> View
      </button>

      <Modal
        visible={isModalVisible}
        width="90%"
        className={classes.modal}
        footer={null}
        onCancel={handleCancel}
        zIndex={1050}
        title="Document Preview"
        destroyOnClose
        bodyStyle={{ height: '80vh', padding: 0 }}
      >
        {isModalVisible && <PdfRenderer url={url} loading={isLoading} />}
      </Modal>
    </div>
  );
};

const StyledAttachmentLink = withStyles(styles, { injectTheme: true })(AttachmentLink);

export const renderAttachmentLink = (url: string) => {
  return <StyledAttachmentLink url={url} />;
};
